export default __webpack_public_path__ + "static/media/issuer-bilibili.b20a43ee.svg";